var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.4,
    height: 16,
    viewBox: "0 0 14.4 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_3",
    "data-name": 3,
    d: "M4.8,1.6V.8A.8.8,0,0,1,5.6,0H8.8a.8.8,0,0,1,.8.8v.8h3.2a1.6,1.6,0,0,1,1.6,1.6V4a1.6,1.6,0,0,1-1.6,1.6h-.108l-.544,8.16A2.4,2.4,0,0,1,9.756,16H4.66a2.4,2.4,0,0,1-2.392-2.236L1.708,5.6H1.6A1.6,1.6,0,0,1,0,4V3.2A1.6,1.6,0,0,1,1.6,1.6Zm8,1.6H1.6V4H12.8ZM3.312,5.6l.552,8.056a.8.8,0,0,0,.8.744h5.1a.8.8,0,0,0,.8-.748L11.088,5.6ZM5.6,6.4a.8.8,0,0,1,.8.8v5.6a.8.8,0,1,1-1.6,0V7.2A.8.8,0,0,1,5.6,6.4Zm3.2,0a.8.8,0,0,1,.8.8v5.6a.8.8,0,0,1-1.6,0V7.2A.8.8,0,0,1,8.8,6.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.1fceacb49067b19117c023bcae4173ba.svg";
export { ForwardRef as ReactComponent };